<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Check-In" childName="Badges"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading v-if="event" title="Badges"></heading>
        <!-- 
        <button class="btn">
          <img class="white_icon" src="@/assets/img/plus.svg" />Add Badge
        </button>-->
        <div class="badges-selectors">
          <div class="select-attendees">
            <span>Select Attendees:</span>
            <v-select v-model="selectedOption" :options="options.select" :placeholder="options.select[0]" />
          </div>
       
          <div class="select-badge-style">
            <span>Select Badge Style:</span>
            <v-select :options="options.badgeStyle" :placeholder="options.badgeStyle[0]" />
          </div>
        </div>

        <div class="badge-layout">
          <h3>Event Badge Layout</h3>
          <table class="badge-table">
            <thead>
              <td>Line</td>
              <td>Text</td>
              <td>Font</td>
              <td>Font Size</td>
            </thead>
            <tbody>
              <tr>
                <td data-label="Line">1</td>
                <td data-label="Text">
                  <v-select :options="options.badgeLayout" placeholder="Select a Field" />
                </td>

                <td data-label="Font">
                  <v-select :options="options.font" :placeholder="options.font[0]" />
                </td>

                <td data-label="Font Size">
                  <v-select :options="options.fontSize" :placeholder="options.fontSize[0]" />
                </td>
              </tr>

              <tr>
                <td data-label="Line">2</td>
                <td data-label="Text">
                  <v-select :options="options.badgeLayout" placeholder="Select a Field" />
                </td>
                <td data-label="Font">
                  <v-select :options="options.font" :placeholder="options.font[0]" />
                </td>
                <td data-label="Font Size">
                  <v-select :options="options.fontSize" :placeholder="options.fontSize[0]" />
                </td>
              </tr>

              <tr>
                <td data-label="Line">3</td>
                <td data-label="Text">
                  <v-select :options="options.badgeLayout" placeholder="Select a Field" />
                </td>
                <td data-label="Font">
                  <v-select :options="options.font" :placeholder="options.font[0]" />
                </td>
                <td data-label="Font Size">
                  <v-select :options="options.fontSize" :placeholder="options.fontSize[0]" />
                </td>
              </tr>

              <tr>
                <td data-label="Line">4</td>
                <td data-label="Text">
                  <v-select :options="options.badgeLayout" placeholder="Select a Field" />
                </td>
                <td data-label="Font">
                  <v-select :options="options.font" :placeholder="options.font[0]" />
                </td>
                <td data-label="Font Size">
                  <v-select :options="options.fontSize" :placeholder="options.fontSize[0]" />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="generate-button">
            <button class="orange-button">Generate Badges</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title
  },
  data() {
    return {
      event: null,
      selectedOption: null,
      tickets: {
        total: 100,
        sold: 50
      },
      options: {
        select: [
          "All",
          "Individual",
          "Attendees by Ticket Type"
        ],
        selectBy: ["First Name", "Last Name", "Email Address"],
        badgeStyle: ["Laminated ID Cards"],
        badgeLayout: [
          "First Name Last Name",
          "Event Name",
          "Ticket Type",
          "First Name",
          "Last Name",
          "Email Address",
          "Billing Address",
          "Home Address"
        ],
        font: [
          "Courier",
          "Courier-Bold",
          "Courier-BoldOblique",
          "Courier-Oblique",
          "Helvetica",
          "Helvetica-Bold",
          "Helvetica-BoldOblique",
          "Helvetica-Oblique",
          "Times-Bold",
          "Times-BoldItalic",
          "Times-Italic",
          "Times-Roman",
          "CJK Unicode Font"
        ],
        fontSize: [
          "7pt",
          "8pt",
          "9pt",
          "10pt",
          "11pt",
          "12pt",
          "14pt",
          "16pt",
          "18pt",
          "20pt",
          "24pt",
          "28pt",
          "32pt",
          "36pt",
          "40pt",
          "45pt",
          "50pt"
        ]
      },
      progress: "0%"
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id)
    };
  },
  watch:{
    selectedOption(){
      if(this.selectedOption) this.showPopup = true
      else this.showPopup = false
    },
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss">
.badge-table {
  td {
    &:first-child {
      width: unset !important;
    }
    width: 30%;
  }
}

.badges-selectors {
  div {
    margin-bottom: 15px;
  }
  .vs__selected-options, .vs__actions {
    margin-bottom: unset;
  }
  span {
    display: inline-block;
    margin-bottom: 5px;
  }
}
.generate-button {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 10px;
  .orange-button {
    margin-top: 10px;
    background-color: #fba500;
    padding: 10px 20px 10px 20px;
    color: white;
    font-size: 15px;
    border: none;
    border-radius: 3px;

  }
}

@media screen and (max-width: 700px) {
  .generate-button{
    justify-content: center;
  }

  tbody{
    td{
          width: 100% !important;
    }
  }
}
</style>

